import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { TicketsPage } from './TicketsPage';

/** Tickets (PC722). A customer's tickets (PC87) are a page of the customer workspace. */
export const ticketsRoutes: RouteObject[] = [
  {
    path: 'tickets',
    element: (
      <RequirePermission code="PC722">
        <TicketsPage />
      </RequirePermission>
    ),
  },
];
